const formatToEuro = (number: number | undefined): string => {
  if (!number) return "";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(number);
};

export { formatToEuro };
